import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterButton from "../filterbutton/filterbutton.component";
import { getGenreFilters, getStatusFilters, getTypeFilters, getCinemaFilters, storeSelectedMovieFilters } from '../../actions/filters.actions';
import { getAllMovies, getRecentMoviesPage } from '../../actions/movies.actions';

class Filters extends Component {

    constructor(props){
        super(props);
        this.state = {
            selectedGenres: [],
            selectedStatus: [],
            selectedCinemas: [],
            selectedFilmType: [],
            selectedStatusFilters: ["avanpremieră", "premieră", "acum in cinema"]
        }
    }
    componentWillMount() {
        this.props.getGenreFilters();
        this.props.getStatusFilters();
        this.props.getTypeFilters();
        this.props.getCinemaFilters();
        this.props.storeSelectedMovieFilters();
        if (this.props.component === "recentMovies"){
            this.props.storeSelectedMovieFilters("&film_status_target_id[]=30&film_status_target_id[]=31&film_status_target_id[]=32");
            this.setState({selectedStatus: ["30","31","32"]});
        }
    }

    genreFilters = (key) =>  {
        if (!this.state.selectedGenres.includes(key)){ 
            this.setState({selectedGenres: [...this.state.selectedGenres, key]})
        }
        else{
            let filteredArray = this.state.selectedGenres.filter(item => item !== key)
            this.setState({selectedGenres: filteredArray})
        }
    }

    statusFilters = (key) => {
        if (!this.state.selectedStatus.includes(key)){ 
            this.setState({selectedStatus: [...this.state.selectedStatus, key]})
        }
        else{
            let filteredArray = this.state.selectedStatus.filter(item => item !== key)
            this.setState({selectedStatus: filteredArray})
        }
    }

    filmTypeFilters = (key) => {
        if (!this.state.selectedFilmType.includes(key)){ 
            this.setState({selectedFilmType: [...this.state.selectedFilmType, key]})
        }
        else{
            let filteredArray = this.state.selectedFilmType.filter(item => item !== key)
            this.setState({selectedFilmType: filteredArray})
        }
    }

    cinemaFilters = (key) => {
        if (!this.state.selectedCinemas.includes(key)){ 
            this.setState({selectedCinemas: [...this.state.selectedCinemas, key]})
        }
        else{
            let filteredArray = this.state.selectedCinemas.filter(item => item !== key)
            this.setState({selectedCinemas: filteredArray})
        }
    }

    getFilmGenreFilters = () => {
        return this.props.film_genre.map((filter, i) => {
            return <FilterButton handleInteractivity={() => this.genreFilters(`${filter.id}`)} interactivity={true} appearance={'styled'} selected={false} label={filter.name} key={i}/>
        });
    };

    getFilmStatusFilters = () => {
        return this.props.film_status.map((filter, i) => {
            if (this.props.component === "recentMovies" && this.state.selectedStatusFilters.includes(filter.name)){
                return <FilterButton handleInteractivity={() => this.statusFilters(`${filter.id}`)} interactivity={true} appearance={'styled'} selected={true} label={filter.name} key={i}/>
            } else {
                if(this.props.component === "allMovies") {
                    return <FilterButton handleInteractivity={() => this.statusFilters(`${filter.id}`)} interactivity={true} appearance={'styled'} selected={false} label={filter.name} key={i}/>
                }
            }

        });
    };

    getFilmTypeFilters = () => {
        return this.props.film_type.map((filter, i) => {
            return <FilterButton handleInteractivity={() => this.filmTypeFilters(`${filter.id}`)} interactivity={true} appearance={'styled'} selected={false} label={filter.name} key={i}/>
        });
    };

    getFilmCinemaFilters = () => {
        return this.props.film_cinema.map((filter, i) => {
            return <FilterButton handleInteractivity={() => this.cinemaFilters(`${filter.cinema_id}`)} interactivity={true} appearance={'styled'} selected={false} label={filter.cinema_name} key={i}/>
        });
    };

    requestFilter = () => {
        let selectedGenres = "";
        let selectedStatus = "";
        let selectedCinemas = "";
        let selectedFilmType = "";
        this.state.selectedGenres.forEach(item => {
            selectedGenres = selectedGenres.concat(`&film_genre_target_id[]=${item}`)
        })
        this.state.selectedStatus.forEach(item => {
            selectedStatus = selectedStatus.concat(`&film_status_target_id[]=${item}`)
        })
        this.state.selectedCinemas.forEach(item => {
            selectedCinemas = selectedCinemas.concat(`&film_cinemas_target_id[]=${item}`)
        })
        this.state.selectedFilmType.forEach(item => {
            selectedFilmType = selectedFilmType.concat(`&film_projection_formats_target_id[]=${item}`)
        })
        const payload = selectedGenres.concat(selectedStatus, selectedCinemas, selectedFilmType);
        
        if(this.props.component === "allMovies"){
            this.props.sortBy ? this.props.getAllMovies(payload + this.props.sortBy) : this.props.getAllMovies(payload);
            this.props.storeSelectedMovieFilters(payload);
            window.scrollTo(0, 0);
        }
        else{
            this.props.sortBy ? this.props.getRecentMoviesPage(payload + this.props.sortBy) : this.props.getRecentMoviesPage(payload) ;
            this.props.storeSelectedMovieFilters(payload);
            window.scrollTo(0, 0);
        }
    }

    render() {
        return (
            <div className="filters">
                <div className="filters-head">
                    CATEGORII
                </div>
                <div className="filters-content clearfix">
                    <div className="row no-gutters">
                        <div className="filters-head-text partial-border">FILTREAZĂ DUPĂ GEN</div>
                        <div className="filters-buttons">
                            { this.getFilmGenreFilters() }
                        </div>

                        <div className="filters-head-text partial-border">STATUS</div>
                        <div className="filters-buttons">
                            { this.getFilmStatusFilters() }
                        </div>

                        <div className="filters-head-text partial-border">CINEMATOGRAF</div>
                        <div className="filters-buttons normal-checkboxes">
                            { this.getFilmCinemaFilters() }
                        </div>

                        <div className="filters-head-text partial-border">TIP</div>
                        <div className="filters-buttons">
                            { this.getFilmTypeFilters() }
                        </div>

                        <div className="col-12 filter-area clearfix">
                            <div className="btn-cinemap-dark filter-movies" onClick={this.requestFilter}>
                                FILTREAZĂ
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    film_genre: state.filters.film_genre,
    film_status: state.filters.film_status,
    film_type: state.filters.film_type,
    film_cinema: state.filters.film_cinema,
    sortBy: state.filters.movies_filters.selected_sortBy
});
export default connect(mapStateToProps, {
    getGenreFilters,
    getStatusFilters,
    getTypeFilters,
    getCinemaFilters,
    getAllMovies,
    getRecentMoviesPage,
    storeSelectedMovieFilters
})(Filters);




// WEBPACK FOOTER //
// ./src/SHARED/components/filters/filters.component.js